import { Link } from 'react-router-dom';
import { articles } from '@/mocks/homeData';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
              最新<strong className="text-primary-500">平台资讯</strong>
            </h2>
            <p className="text-foreground-600 text-sm">了解j9平台最新动态和实用指南</p>
          </div>
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}